import { IconProps } from './Icon.types';

export const UserIcon = ({ style, className, fill, width, height }: IconProps) => {
  return (
    <svg
      version="1.2"
      preserveAspectRatio="none"
      viewBox="0 0 24 24"
      className={className}
      style={{
        width,
        height,
        fill: fill ? fill : 'rgb(94, 94, 94)',
        ...style,
      }}
    >
      <g>
        <path
          d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
          style={{ fill: fill ? fill : 'rgb(94, 94, 94)' }}
        />
      </g>
    </svg>
  );
};
